import { DELIVERY, LEVEL_VALUES } from 'containers/AwarenessCenter/constants'
import { COPY_SCENARIO_ASYNC } from 'containers/AwarenessCenter/Scenarios/constants'
import {
  CHANGE_DELIVERY,
  RESET_WIZARD,
} from 'containers/AwarenessCenter/WizardCampaign/steps/constants'

import { CHANGE_LOCALES_BY_PROFILES } from '../../WizardSimulationCampaign/constants'

import {
  AUTO_SELECT_SCENARIOS_ASYNC,
  CHANGE_ATTACK_VECTOR,
  CHANGE_CREATED_BY_FILTER,
  CHANGE_LEVEL_FILTER,
  CHANGE_LOCALES,
  CHANGE_SORT_OPTION,
  CHANGE_TYPE_FILTER,
  DEFAULT_CATEGORY_ID,
  FETCH_CATEGORIES_ASYNC,
  PICK_CATEGORY,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SET_IS_VISITED,
  SORT_VALUES,
  TYPE_VALUES,
} from './constants'

export default function () {
  const initialState = {
    error: null,
    data: {
      allCategories: {},
      categories: {},
    },
    scenariosLoader: false,
    search: '',
    sortOption: SORT_VALUES.LAST_UPDATED,
    levelFilter: LEVEL_VALUES.ALL_LEVELS,
    typeFilter: TYPE_VALUES.ALL_TYPES,
    attackVector: null,
    createdByFilter: [],
    pickedCategoryId: null,
    locales: [],
    isVisited: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          scenariosLoader: true,
          search: action.payload.q,
        }
      case CHANGE_SORT_OPTION:
        return {
          ...state,
          scenariosLoader: true,
          sortOption: action.payload.value,
        }
      case CHANGE_LEVEL_FILTER:
        return {
          ...state,
          scenariosLoader: true,
          levelFilter: action.payload.value,
        }
      case CHANGE_ATTACK_VECTOR:
        return { ...state, attackVector: action.payload.value }
      case CHANGE_TYPE_FILTER:
        return {
          ...state,
          scenariosLoader: true,
          typeFilter: action.payload.value,
          attackVector:
            state.attackVector?.type === action.payload.value ? state.attackVector : null,
        }
      case CHANGE_DELIVERY:
        return {
          ...state,
          typeFilter: TYPE_VALUES.ALL_TYPES,
          attackVector: null,
        }
      case CHANGE_CREATED_BY_FILTER:
        return {
          ...state,
          scenariosLoader: true,
          createdByFilter: action.payload.array,
        }
      case PICK_CATEGORY:
        return {
          ...state,
          scenariosLoader: true,
          pickedCategoryId: action.payload.categoryId,
        }
      case FETCH_CATEGORIES_ASYNC.INITIATE:
        return {
          ...state,
          scenariosLoader: true,
          pickedCategoryId: DEFAULT_CATEGORY_ID[DELIVERY.EMAIL],
        }
      case FETCH_CATEGORIES_ASYNC.SUCCESS:
        return {
          ...state,
          scenariosLoader: false,
          data: {
            ...state.data,
            categories: action.payload.data,
          },
        }
      case FETCH_CATEGORIES_ASYNC.ERROR:
      case FETCH_CATEGORIES_ASYNC.CANCEL:
        return {
          ...state,
          scenariosLoader: false,
        }
      case AUTO_SELECT_SCENARIOS_ASYNC.INITIATE:
        return {
          ...state,
        }
      case AUTO_SELECT_SCENARIOS_ASYNC.ERROR:
      case AUTO_SELECT_SCENARIOS_ASYNC.CANCEL:
        return {
          ...state,
        }
      case AUTO_SELECT_SCENARIOS_ASYNC.SUCCESS:
        return {
          ...state,
        }
      case RESET_WIZARD:
        return {
          ...initialState,
        }
      case COPY_SCENARIO_ASYNC.INITIATE:
        return {
          ...state,
          scenariosLoader: true,
        }
      case COPY_SCENARIO_ASYNC.SUCCESS:
        return {
          ...state,
          scenariosLoader: false,
        }
      case COPY_SCENARIO_ASYNC.ERROR:
        return {
          ...state,
          scenariosLoader: false,
        }
      case CHANGE_LOCALES_BY_PROFILES:
        return {
          ...state,
          sortOption: action.payload.value
            ? SORT_VALUES.LANGUAGES_MATCH_SORT
            : SORT_VALUES.LAST_UPDATED,
        }
      case CHANGE_LOCALES:
        return {
          ...state,
          locales: action.payload.value,
        }
      case SET_IS_VISITED: {
        return {
          ...state,
          isVisited: action.payload.value,
        }
      }
      default:
        return state
    }
  }
}
